import { render, staticRenderFns } from "./SelectChips.vue?vue&type=template&id=dea0e6b2&"
import script from "./SelectChips.vue?vue&type=script&lang=js&"
export * from "./SelectChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VChip,VCombobox,VSelect})
